import { render, staticRenderFns } from "./ModulesCarousel.vue?vue&type=template&id=676c6082"
import script from "./ModulesCarousel.vue?vue&type=script&lang=js"
export * from "./ModulesCarousel.vue?vue&type=script&lang=js"
import style0 from "./ModulesCarousel.vue?vue&type=style&index=0&id=676c6082&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports